import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Linkify from 'linkify-it';
import React, { Component } from 'react';
import tlds from 'tlds';
import isHotKey from 'is-hotkey';
import { Value, Inline, Text } from 'slate';
import { LinkIcon } from '../../components/Icons';
import LinkPreview from './components/LinkPreview';
import LinkComponent from './components/Link';
import EntityTypes from '../../types/EntityTypes';
import renderInlines from '../utils/renderInlines';
import renderMarks from '../utils/renderMarks';
import renderDecorations from '../utils/renderDecorations';
import makeKeyboardCommandShortcut from '../utils/makeKeyboardCommandShortcut';
import getSelectedText from '../utils/getSelectedText';
import { normalizeNode, shouldHaveText } from '../utils/NormalizationHelper';
import { Editor } from '../..';
import MentionPickerPlugin from '../MentionPickerPlugin';
import decorateNode from './utils/decorateNode';
import serializers from './serializers';
import deserializers from './deserializers';
import LinkStrategy from './linkStrategy';
import makeToolbarButton, { BASIC_SELECTION, EXPANDED_SELECTION } from '../utils/makeToolbarButton';
import renderToolbarPrompt from '../utils/renderToolbarPrompt';
import ToolbarPrompt from '../../components/ToolbarPrompt';
import makeMarkdownInlineShortcut from '../utils/makeMarkdownInlineShortcut';
var linkify = Linkify().tlds(tlds).set({
  fuzzyIP: true
});
var schema = {
  rules: []
};

var InputComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(InputComponent, _Component);

  function InputComponent(props) {
    var _this;

    _classCallCheck(this, InputComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputComponent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onEditorRef", function (editor) {
      _this.editor = editor;
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (editor) {
      _this.setState({
        value: editor.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event, _, next) {
      if (isHotKey('escape', event)) {
        return _this.props.editor.command('closePrompt');
      }

      if (isHotKey('shift+enter', event)) {
        return event.preventDefault();
      }

      next();
    });

    var fetchNotes = props.fetchNotes,
        _editor = props.editor,
        appDomain = props.appDomain,
        organizationDomain = props.organizationDomain,
        showNoteByToken = props.showNoteByToken;
    _this.state = {
      value: Value.fromJSON({
        object: 'value',
        document: {
          nodes: [{
            object: 'block',
            type: 'paragraph',
            nodes: [{
              object: 'text',
              text: _this.props.link || ''
            }]
          }]
        },
        selection: {
          isFocused: true
        }
      })
    };
    _this.plugins = [{
      schema: {
        document: {
          nodes: [{
            match: {
              type: 'paragraph'
            },
            min: 1,
            max: 1
          }]
        }
      },
      onKeyDown: _this.onKeyDown
    }, MentionPickerPlugin({
      customStrategies: [LinkStrategy({
        fetchNotes: fetchNotes,
        editor: _editor,
        appDomain: appDomain,
        organizationDomain: organizationDomain,
        showNoteByToken: showNoteByToken
      })],
      searchSymbol: ''
    })];
    return _this;
  }

  _createClass(InputComponent, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "flexbox-grow"
      }, React.createElement("div", {
        className: 'position-relative line-height-larger',
        style: {
          wordBreak: 'break-word',
          fontSize: 15
        }
      }, React.createElement(Editor, {
        value: this.state.value,
        readOnly: false,
        onChange: this.onChange,
        placeholder: "Link to a note or a web page",
        plugins: this.plugins
      })));
    }
  }]);

  return InputComponent;
}(Component);

function isLink(editor) {
  var inlines = editor.value.inlines;

  if (inlines && inlines.size === 1) {
    var inline = editor.value.document.getNode(inlines.first().key);
    var inlineText = inline.getLastText().text;
    var selectionText = getSelectedText(editor);
    return selectionText === inlineText;
  }

  return false;
}

export { LinkPreview, linkify, schema };
export default function LinkPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (x) {
    return x;
  } : _ref$decorator,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$fetchNotes = _ref.fetchNotes,
      fetchNotes = _ref$fetchNotes === void 0 ? function () {
    return Promise.resolve([]);
  } : _ref$fetchNotes,
      _ref$appDomain = _ref.appDomain,
      appDomain = _ref$appDomain === void 0 ? '' : _ref$appDomain,
      _ref$organizationDoma = _ref.organizationDomain,
      organizationDomain = _ref$organizationDoma === void 0 ? '' : _ref$organizationDoma,
      _ref$showNoteByToken = _ref.showNoteByToken,
      showNoteByToken = _ref$showNoteByToken === void 0 ? function () {
    return Promise.resolve({});
  } : _ref$showNoteByToken;

  var DecoratedLinkComponent = decorator(LinkComponent);

  var onClickOverridden = function onClickOverridden(event) {
    event.stopPropagation();
    event.preventDefault();
    onClick(event, {
      url: event.currentTarget.href
    });
    return false;
  };

  return [{
    decorateNode: decorateNode,
    serializers: serializers,
    deserializers: deserializers,
    schema: schema,
    commands: {
      insertUrl: function insertUrl(editor, text, url) {
        return editor.insertInline(Inline.create({
          type: EntityTypes.LINK,
          data: {
            url: url
          },
          nodes: [Text.create({
            text: text
          })]
        }));
      }
    }
  }, normalizeNode(EntityTypes.LINK, [shouldHaveText]), renderInlines(_defineProperty({}, EntityTypes.LINK, function (props) {
    return React.createElement(DecoratedLinkComponent, Object.assign({
      url: props.node.getIn(['data', 'url']) || '',
      canRemove: true,
      onClick: props.editor.readOnly ? function () {} : onClickOverridden
    }, props));
  })), renderMarks(_defineProperty({}, EntityTypes.LINK, function (props) {
    return React.createElement(DecoratedLinkComponent, Object.assign({
      url: props.mark.data.get('url') || '',
      onClick: props.editor.readOnly ? function () {} : onClickOverridden
    }, props));
  })), renderDecorations(_defineProperty({}, EntityTypes.LINK, function (props) {
    return React.createElement(DecoratedLinkComponent, Object.assign({
      url: props.decoration.data.get('url') || '',
      onClick: props.editor.readOnly ? function () {} : onClickOverridden
    }, props));
  })), renderToolbarPrompt(_defineProperty({}, EntityTypes.LINK, function (props) {
    var link = null;

    if (isLink(props.editor)) {
      var inlines = props.editor.value.inlines;
      var inline = props.editor.value.document.getNode(inlines.first().key);
      link = inline.data.get('url');
    }

    return React.createElement(ToolbarPrompt, Object.assign({}, props, {
      icon: LinkIcon,
      value: link,
      autoSelection: true,
      withSubmit: false,
      input: InputComponent,
      inputProps: {
        fetchNotes: fetchNotes,
        editor: props.editor,
        link: link,
        appDomain: appDomain,
        organizationDomain: organizationDomain,
        showNoteByToken: showNoteByToken
      }
    }));
  })), makeToolbarButton(EntityTypes.LINK, {
    icon: LinkIcon,
    title: 'Link to URL',
    visibility: BASIC_SELECTION | EXPANDED_SELECTION,
    isActive: function isActive(editor) {
      return editor.isActiveInline(EntityTypes.LINK);
    },
    onApply: function onApply(editor) {
      return editor.command('openPrompt', EntityTypes.LINK);
    }
  }), makeKeyboardCommandShortcut('mod+k', {
    type: EntityTypes.LINK,
    command: function command(editor) {
      return editor.command('openPrompt', EntityTypes.LINK);
    },
    canApply: function canApply(editor) {
      return editor.value.selection.isExpanded;
    }
  }), makeMarkdownInlineShortcut(/(\[.+?\]\(.+?)$/, function (editor, event, matches) {
    var _$exec = /\[(.+?)\]\((.+?)$/.exec(matches.before[0]),
        _$exec2 = _slicedToArray(_$exec, 3),
        text = _$exec2[1],
        url = _$exec2[2];

    return editor.insertUrl(text, url);
  }, undefined, {
    trigger: 'shift?+)',
    byKey: true
  })];
}
LinkPlugin.LinkPreview = LinkPreview;